import { defineModel } from 'foca';
import { parrotApi } from '@libs/openapi';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';

export type CoinStructArray = OpenapiClientParrotVault.GetVaultCoinsResponse;
export type CoinStruct = CoinStructArray[number];

interface coinStateStruct {
  loading: Record<string, boolean>;
  coins: Record<string, CoinStruct>;
  cacheCoins: CoinStructArray;
}

const initialState: coinStateStruct = {
  loading: {},
  coins: {},
  cacheCoins: [],
};

export const coinsVaultModel = defineModel('coins-vault', {
  initialState,
  methods: {
    async getCoins() {
      const result = await parrotApi.get('/vault/coins', {});

      let coins: Record<string, CoinStruct> = {};

      result.forEach((coin) => {
        coins[coin.coin_type] = coin;
      });

      this.setState({
        cacheCoins: result,
        coins,
      });
      return result;
    },
  },
});
